module.exports = __webpack_public_path__ + "img/np.69c57d63.svg";